import { LOGOUT } from '#modules/state/LogOutAction';

const initialState = {
  page: undefined,
};

const CURRENT_SETTING_PAGE = 'tokenized/settings/CURRENT_SETTING_PAGE';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CURRENT_SETTING_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function setCurrentSettingsPageAction(page) {
  return { type: CURRENT_SETTING_PAGE, payload: page };
}

export const selectCurrentSettingsPage = (state) => state.settings?.page;
